import React, { Component } from 'react';
import PropTypes from 'prop-types';
import takerBlockComponentsConfig from 'config/takerBlockComponentsConfig';
import genericQuestionPropType from '../config/genericQuestionPropType';
import propTypeBlockStyling from '../domains/styling/config/editorBlock/PropTypes/blockStyling';
import withSurveyItemStyling from '../domains/styling/hocs/withSurveyItemStyling';

class SurveyTakerBlock extends Component {
  static propTypes = {
    block: genericQuestionPropType,
    questionNumber: PropTypes.number,
    isInPreviewMode: PropTypes.bool,
    isCloned: PropTypes.bool,
    isInAIOMode: PropTypes.bool,
    onAnswer: PropTypes.func.isRequired,
    answer: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.object,
      PropTypes.array,
    ]),
    pageIndex: PropTypes.number,
    pageNumber: PropTypes.number,
    readOnly: PropTypes.bool,
    styling: propTypeBlockStyling,
  };

  static defaultProps = {
    isInAIOMode: false,
    isInPreviewMode: false,
    pageNumber: null,
    styling: undefined,
  };

  handleAnswer = value => {
    const { block, onAnswer } = this.props;

    return onAnswer(block.id, value);
  };

  render = () => {
    const {
      isInAIOMode,
      block,
      answer,
      pageIndex,
      pageNumber,
      isInPreviewMode,
      readOnly,
      styling,
      questionNumber,
      isCloned,
    } = this.props;

    const TakerComponent = takerBlockComponentsConfig[block.type];

    return (
      <TakerComponent
        isInPreviewMode={isInPreviewMode}
        isInAIOMode={isInAIOMode}
        isCloned={isCloned}
        block={block}
        questionNumber={questionNumber}
        answer={answer}
        onAnswer={this.handleAnswer}
        pageIndex={pageIndex}
        pageNumber={pageNumber}
        readOnly={readOnly}
        styling={styling}
      />
    );
  };
}
export default withSurveyItemStyling(SurveyTakerBlock);
